// extracted by mini-css-extract-plugin
module.exports = {"header":"fixed-text-top-bar_header__2Aio6","textContainer":"fixed-text-top-bar_textContainer__26BJ9"};